import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useNavigate } from 'react-router';

import EnvironmentLabel from '../components/environmentLabel';

import { useAuth } from '../utility/auth';

interface Props {
  children: any;
}

const Layout: React.FC<Props> = ({ children }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const sm = useMediaQuery('(min-width: 882px)');

  return (
    <>
      <header>
        <AppBar position="static">
          <Toolbar>
            <Box>
              {sm ? 'MerchantExp Admin' : ''} <EnvironmentLabel environmentName={import.meta.env.VITE_ENV || 'LOCAL'} />
            </Box>
            {auth.user && (
              <>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    navigate('/');
                  }}
                  startIcon={<HomeIcon />}>
                  {sm ? 'Home' : ''}
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    navigate('/userlookup');
                  }}
                  startIcon={<SearchIcon />}>
                  {sm ? 'Application Lookup' : ''}
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    navigate('/configlookup');
                  }}
                  startIcon={<SearchIcon />}>
                  {sm ? 'Config Lookup' : ''}
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    navigate('/userclientlookup');
                  }}
                  startIcon={<SearchIcon />}>
                  {sm ? 'User Client Lookup' : ''}
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    navigate('/iframetesting');
                  }}
                  startIcon={<SearchIcon />}>
                  {sm ? 'OD iFrame Test' : ''}
                </Button>
                <Box sx={{ marginLeft: 'auto' }}> {sm ? auth.user : ''} </Box>
                <IconButton
                  size="large"
                  id="account-menu-button"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={'account-menu'}
                  aria-haspopup="true"
                  role="button"
                  onClick={handleMenu}
                  color="inherit">
                  <AccountCircle />
                </IconButton>
                <Menu id="account-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                  <MenuItem
                    onClick={() => {
                      setAnchorEl(null);
                      auth.logout(() => navigate('/'));
                    }}>
                    Sign out
                  </MenuItem>
                </Menu>
              </>
            )}
          </Toolbar>
        </AppBar>
      </header>
      <main>
        <>
          <img className="team-image" src="/teamCrest.png" alt="" />
          {children}
        </>
      </main>
    </>
  );
};

export default Layout;
